/* eslint-disable react/prop-types */
import { Box, TableCell, TableRow } from "@mui/material";
import moment from "moment/moment";
import React from "react";
import tableStyle from "../../theme/styles/table";
import { getGohonzonType } from "../../utils";
import { isEmptyObj } from "../../utils/helper";
import Button from "../common/Button";
import DatePicker from "../common/new/DatePicker/DatePicker";
import { style } from "./styles";
import Colors from "../../theme/colors";

const DISABLE_STATUS = [
  "CONFERRED",
  "ALLOTMENT_CANCELLATION_REQUESTED",
  "ALLOTMENT_CANCELLED",
  "CANCELLED",
];

function GohonzonConferral({
  member,
  onApplicationConferral,
  onCancelRequestApplication,
}) {
  const { memberDetails } = member;
  if (isEmptyObj(member) || isEmptyObj(member.memberDetails)) {
    return null;
  }

  const onDateSelect = (conferredDate) => {
    onApplicationConferral(member, conferredDate);
  };

  const disabledBtn = DISABLE_STATUS.includes(member.status);

  return (
    <TableRow style={tableStyle.tableRow}>
      <TableCell style={{ ...style.Cell, color: "#043D90", fontWeight: "600" }}>
        {member.memberId}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.fullName || "-"}
        <br />
        {memberDetails.addressLine1 || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.mobileNumber || "-"}
        <br />
        {memberDetails.emailId || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.divisionName || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {getGohonzonType(member.gohonzonType) || "-"}
      </TableCell>
      <TableCell style={style.Cell}>
        {memberDetails.fullName || "-"}
        <br />
        {/* {member.createAt !== null ? moment(member.createdAt).format("L") : "-"} */}
        {member.createdAt ? moment(member.createdAt).format("DD/MM/YYYY") : "-"}
      </TableCell>
      <TableCell style={{ ...style.Cell }}>
        <Box style={style.status}>{member?.statusValue}</Box>
      </TableCell>
      <TableCell style={{ ...style.Cell }}>
        {/* {member.conferredDate ? moment(member.conferredDate).format("L") : "-"} */}
        {member.conferredDate
          ? moment(member.conferredDate).format("DD/MM/YYYY")
          : "-"}
      </TableCell>
      <TableCell style={{ color: "#8C8C8C" }}>
        <Box style={{ ...style.ActionBtnContainer }}>
          <DatePicker
            disabled={disabledBtn}
            onDateSelect={onDateSelect}
            maxDate={new Date()}
          >
            <Button
              // disabled={disabledBtn}
              variant="outlined"
              style={
                disabledBtn
                  ? {
                      ...style.actionBtn,
                      opacity: ".5",
                      pointerEvents: "none",
                      marginBottom: "10px",
                      width: "80px",
                    }
                  : { ...style.actionBtn, marginBottom: "10px", width: "80px" }
              }
              label="CONFERRAL"
            />
          </DatePicker>
          <Button
            // disabled={disabledBtn}
            onClick={() => onCancelRequestApplication(member)}
            variant="outlined"
            style={
              disabledBtn
                ? {
                    ...style.actionBtn,
                    opacity: ".5",
                    pointerEvents: "none",
                    marginBottom: "10px",
                    width: "80px",
                    color: Colors.midnightBlue,
                  }
                : { ...style.actionBtn, marginBottom: "10px", width: "80px" }
            }
            label="CANCEL"
          />
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default GohonzonConferral;
